export const getDownloadData = state => state.DownloadR.download;
export const getError = state => state.DownloadR.error;